"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableDeprecated = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const Box_1 = require("./Box");
const ClickableElement = styled_1.default.button((props) => ({
    padding: 0,
    background: 'none',
    border: 'none',
    ...(0, Box_1.box)(props),
    cursor: props.cursor ?? 'pointer',
    ':hover': {
        color: props.hoverColor,
        backgroundColor: props.hoverBackgroundColor,
        ...(props.darkenOnHover && {
            filter: 'brightness(0.95)',
        }),
    },
}));
/**
 * @deprecated
 */
exports.ClickableDeprecated = (0, react_1.forwardRef)((props, ref) => {
    const { children, accessKey, ...elementProps } = props;
    return ((0, jsx_runtime_1.jsx)(ClickableElement, { ...elementProps, accessKey: accessKey, ref: ref, children: children }));
});
exports.ClickableDeprecated.displayName = 'ClickableDeprecated';
